import * as React from 'react';

function SvgMapMarker(props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" {...props}>
      <circle cx={75} cy={75} r={75} fill="#38B2A6" fillOpacity={0.19} />
      <circle cx={74.5} cy={74.5} r={46.5} fill="#38B2A6" fillOpacity={0.19} />
      <circle cx={74.5} cy={74.5} r={24.5} fill="#38B2A6" fillOpacity={0.19} />
      <circle cx={74.5} cy={74.5} r={10.5} fill="#38B2A6" fillOpacity={0.19} />
      <g filter="url(#map-marker_svg__a)">
        <path
          d="M60.647 32.624A19.319 19.319 0 0174.279 27a19.319 19.319 0 0113.632 5.624A19.16 19.16 0 0193.557 46.2c0 13.728-7.711 14.538-19.278 28.8C62.712 60.738 55 59.928 55 46.2a19.16 19.16 0 015.647-13.576z"
          fill="#CC3D00"
        />
        <circle cx={74.476} cy={46.397} r={13.574} fill="#fff" />
        <path
          d="M81.274 52.014a.97.97 0 00.284-.686l-.02-8.147a.971.971 0 00-.475-.834l-5.817-3.492a.969.969 0 00-.97 0l-5.817 3.492a.97.97 0 00-.475.834v8.147a.97.97 0 00.97.97h3.684v-4.462a.97.97 0 01.97-.97h2.326a.97.97 0 01.97.97v4.462h3.684a.97.97 0 00.686-.284z"
          fill="#CC3D00"
        />
      </g>
      <defs>
        <filter
          id="map-marker_svg__a"
          x={47}
          y={21}
          width={54.557}
          height={64}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_660_4836" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_660_4836" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgMapMarker;
